import React, { InputHTMLAttributes } from 'react';

interface TextareaFieldProps extends InputHTMLAttributes<HTMLTextAreaElement> {
    value: string;
    name: string;
    label?: string;
    placeholder?: string;
    error?: boolean;
    helperText?: string;
    className?: string;
}

function TextareaField({
    value,
    name,
    label = '',
    placeholder,
    error,
    helperText,
    className,
    ...rest
}: TextareaFieldProps) {
    return (
        <div className="space-y-1">
            {label && <div className=" text-brand font-semibold">{label}</div>}
            <textarea
                value={value}
                name={name}
                placeholder={placeholder}
                className={`rounded-xl focus:ring-brand focus:ring-2 focus:outline-none w-full resize-y  border p-2 ${
                    error ? 'border-red-500' : ''
                } ${className}`}
                {...rest}
            />
            {helperText && (
                <div className={`pl-4 text-xs text-left ${error ? 'text-danger' : 'text-secondary'}`}>{helperText}</div>
            )}
        </div>
    );
}

export default TextareaField;
